import { render } from "./ReviewUserTyres.vue?vue&type=template&id=e7913faa"
import script from "./ReviewUserTyres.vue?vue&type=script&lang=js"
export * from "./ReviewUserTyres.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__